export default __webpack_public_path__ + "static/studio-2-07285fb493d23ed6cf1ef46d48f8350e.jpg";